import {Injectable} from '@angular/core';
import {GuardService} from '../services/guard.service';

@Injectable()
export class AllUsersGuard {

  constructor(private _guardService: GuardService) {
  }

  async canActivate() {
    await this._guardService.isAuth();

    return true;
  }
}
